import pagesIndividualHomeEn from "./home/default";
import pagesIndividualOperationPackageEn from "./operation-package/default";
import pagesIndividualTasksEn from "./tasks/default";

export default {
  home: pagesIndividualHomeEn,
  tasks: pagesIndividualTasksEn,
  operationPackage: pagesIndividualOperationPackageEn,
};
